module.exports = __webpack_public_path__ + "static/media/27OCHA5.c878ebe4.jpg";